// extracted by mini-css-extract-plugin
module.exports =  {"pf-slider":"pf-slider--SyKyB","pfSlider":"pf-slider--SyKyB","with-mark":"with-mark--aplTg","withMark":"with-mark--aplTg"};